import styled, { keyframes, css } from "styled-components";

const ldsEllipsis1 = keyframes`
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
`;

const ldsEllipsis2 = keyframes`
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(24px, 0);
  }
`;

const ldsEllipsis3 = keyframes`
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0);
  }
`;

type LoaderContainerProps = {
	color?: string;
	scheme?: "light" | "dark";
	backgroundColor?: string;
	center?: boolean;
};

const LoaderContainer = styled.div<LoaderContainerProps>`
	display: flex;
	align-items: center;
	width: 100%;
	height: 80px;
	color: ${({ color, scheme }) =>
		color ||
		(scheme === "light"
			? "white"
			: scheme === "dark"
			? "black"
			: "currentColor")};
	background-color: ${({ backgroundColor }) =>
		backgroundColor || "transparent"};
`;

interface BraceProps {
	$center?: boolean;
}

const Brace = styled.div<BraceProps>`
	position: relative;
	min-width: 80px;
	margin: ${({ $center }) => ($center ? "auto" : "0")};
`;

/** Define types for Dot props */
interface DotProps {
	index: number;
}

const Dot = styled.div<DotProps>`
	box-sizing: border-box;
	position: absolute;
	top: 33.33333px;
	width: 13.33333px;
	height: 13.33333px;
	border-radius: 50%;
	background: currentColor;
	animation-timing-function: cubic-bezier(0, 1, 1, 0);

	${({ index }) => {
		if (index === 1)
			return css`
				left: 8px;
				animation: ${ldsEllipsis1} 0.6s infinite;
			`;
		if (index === 2)
			return css`
				left: 8px;
				animation: ${ldsEllipsis2} 0.6s infinite;
			`;
		if (index === 3)
			return css`
				left: 32px;
				animation: ${ldsEllipsis2} 0.6s infinite;
			`;
		if (index === 4)
			return css`
				left: 56px;
				animation: ${ldsEllipsis3} 0.6s infinite;
			`;
	}}
`;

export type LoaderType = "ellipsis";

export interface LoaderProps {
	style?: React.CSSProperties;
	type?: LoaderType;
	scheme?: "light" | "dark";
	color?: string;
	backgroundColor?: string;
	center?: boolean;
}

export const Loader: React.FC<LoaderProps> = ({
	type = "ellipsis",
	style = {},
	scheme,
	color,
	backgroundColor,
	center = false,
}) => {
	return (
		<LoaderContainer
			style={style}
			color={color}
			backgroundColor={backgroundColor}
			scheme={scheme}
			center={center}
		>
			<Brace $center={center}>
				{[1, 2, 3, 4].map((i) => (
					<Dot key={i} index={i} />
				))}
			</Brace>
		</LoaderContainer>
	);
};
